import { render, staticRenderFns } from "./ViewPurchaseOrders.vue?vue&type=template&id=6a669358&lang=pug&"
import script from "./ViewPurchaseOrders.vue?vue&type=script&lang=js&"
export * from "./ViewPurchaseOrders.vue?vue&type=script&lang=js&"
import style0 from "./ViewPurchaseOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports